import { DataTablePaginationFooter } from './DataTablePaginationFooter';

interface EntityListPaginationProps {
  page: number;
  totalPages: number;
  total: number;
  onPrevious: () => void;
  onNext: () => void;
}

export function EntityListPagination({
  page,
  totalPages,
  total,
  onPrevious,
  onNext,
}: EntityListPaginationProps) {
  return (
    <DataTablePaginationFooter
      count={total}
      singular="total"
      countLabel={`${total} total`}
      page={page}
      totalPages={totalPages}
      onPrevious={onPrevious}
      onNext={onNext}
      showPagination
    />
  );
}
